import React from 'react';
import classnames from 'classnames';
import ProductCover from '../../../ts/components/common/productCover/ProductCover';
import { ImageDisplayType } from '../../../ts/components/common/PlaceholderImage';

import './product-list-item.scss';

export enum ReadingListButtonState {
    Hidden,
    Add,
    Edit
}

export interface IProps {    
    id: any;
    title: string;
    link: string;
    authors: string;
    
    coverPath?: string;
    coverPlaceholder?: string;

    codeDownloadLink?: string;
    forumUrl?: string;

    liveaudioOfferingId?: any;

    isMeap?: boolean;
    isLiveproject?: boolean;
    isLiveprojectSeries?: boolean;
    isLivevideo?: boolean;
    isLiveaudio?: boolean;
    isLivebook?: boolean;
    isNew?: boolean;

    readingListButtonState: ReadingListButtonState;

    onReadingListClick?: (productId: any) => void;

    date?: string;

    licenses?: {
        format: string;
        link: string;
    }[];

    data?: string;
    isOwnedByUser?: boolean;
    onDragStart?: (e) => void;

    showAddToReadingListLink?: boolean;
}
export interface IState {
    
}

export class ProductListItem extends React.Component <IProps, IState> {    
    constructor(props: IProps) {
        super(props);

        this.handleReadingListClick = this.handleReadingListClick.bind(this);
    }

    public render(){
        return <div className={classnames("product-list-item-root", {"has-cover": this.props.coverPath})} data-id={this.props.id}>
                    { this.props.coverPath && <div className="product-list-item-cover-container">
                            <ProductCover placeholderImage = {this.props.coverPlaceholder}
                                      imageDisplayType = {ImageDisplayType.Image}
                                      fullImage = {this.props.coverPath}
                                      className = "book-cover"
                                      height={73}
                                      width={58}
                                      alt = {!this.props.title || this.props.title.indexOf("<") >= 0 ? "" : this.props.title}
                                      placeholderOnlyOnFail={false}
                                      data={this.props.data}
                                      onDragStart={this.props.onDragStart}
                                      onClick={() => window.open(this.props.link, "_blank")}/>
                    </div> }
                    <div className="product-list-item-info-column">
                        <div className="product-list-item-header">
                            <div className="product-list-item-header-left">
                                <h4>
                                    <a href={this.props.link} target="_blank" dangerouslySetInnerHTML={{__html: this.props.title}}></a>
                                </h4>
                                { this.renderReadingListButton()}
                                { this.props.isMeap && <img src="https://lx-common-resources.s3.us-west-2.amazonaws.com/resources/meap-badge.svg" alt="this product is in MEAP"/>}
                                { this.props.isNew && <img src="https://lx-common-resources.s3.us-west-2.amazonaws.com/resources/new-badge.svg" alt="updated within last two weeks"/>}
                                { this.props.isLiveaudio && <img src="https://lx-common-resources.s3.us-west-2.amazonaws.com/resources/liveAudio-badge.svg" alt="this product has audio"/>}
                                { this.props.isLivevideo && <img src="https://lx-common-resources.s3.us-west-2.amazonaws.com/resources/livevideo-badge.svg" alt="this is a video"/>}
                                { this.props.isLiveproject && <img src="https://lx-common-resources.s3.us-west-2.amazonaws.com/resources/liveproject-badge.svg" alt="this is a project"/>}
                                { this.props.isLiveprojectSeries && <img src="https://lx-common-resources.s3.us-west-2.amazonaws.com/resources/liveproject-badge.svg" alt="this is a project series"/>}
                            </div>
                            <div className="product-list-item-header-right">
                                { this.props.codeDownloadLink 
                                && <a href={this.props.codeDownloadLink} target="_blank">
                                    <svg width="22" height="18" viewBox="0 0 22 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M12.3252 0.050293L7.66765 17.4325L9.5995 17.9501L14.257 0.567931L12.3252 0.050293Z" fill="#333333"/>
                                        <path d="M6.61222 15.361L7.97161 13.9126L7.9711 13.8935L2.87681 9.11226L7.66724 4.00816L6.20892 2.63947L0.0498047 9.20188L6.61222 15.361Z" fill="#333333"/>
                                        <path d="M15.3883 15.361L14.0289 13.9126L14.0294 13.8935L19.1237 9.11226L14.3333 4.00816L15.7916 2.63947L21.9507 9.20188L15.3883 15.361Z" fill="#333333"/>
                                    </svg>
                                </a>}
                                { this.props.forumUrl
                                && <a href={this.props.forumUrl} target="_blank">
                                    <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M0 2C0 0.895386 0.895432 0 2 0H10C11.1046 0 12 0.895386 12 2V8C12 9.10461 11.1046 10 10 10H7L2 14L3 10H2C0.895432 10 0 9.10461 0 8V2Z" fill="#333333"/>
                                        <path d="M6 13V12H10C12 12 14 11 14 9V5H16C17.1046 5 18 5.89539 18 7V13C18 14.1046 17.1046 15 16 15H15L16 19L11 15H8C6.89543 15 6 14.1046 6 13Z" fill="#333333"/>
                                    </svg>
                                   </a>}
                            </div>
                        </div>
                        
                        { this.props.authors && <div className="product-list-item-authors-label" dangerouslySetInnerHTML={{__html: this.props.authors}}></div>}
                        
                        <div className="product-list-item-footer">
                            { this.renderDateAndOwnershipLabelIfNecessary()}
                            { !this.props.date && this.props.title && this.props.title.indexOf("loader-text-line") >= 0 
                            && <div className="loader-text-line"></div> }
                            <div>
                                {this.renderFooterLinks()}
                            </div>
                        </div>
                    </div>
                </div>
    }

    private renderDateAndOwnershipLabelIfNecessary(){
        if(this.props.date && this.props.isOwnedByUser){
            return <div>
                        <span className="product-list-item-date-label" dangerouslySetInnerHTML={{__html: this.props.date}}></span>
                        <span className="product-ownership-label">
                            <span>you own this product</span>
                            <i title="you own this product" className="product-ownership-label-icon fa fa-check"/>
                        </span>
                   </div>
        }
        else if(this.props.date) {
            return <div className="product-list-item-date-label" dangerouslySetInnerHTML={{__html: this.props.date}}></div>
        }
        
        return null;
    }

    private renderReadingListButton(){
        if(this.props.onReadingListClick == null 
        || this.props.readingListButtonState == ReadingListButtonState.Hidden) {
            return null;
        }
        
        return <button className="product-list-item-add-to-reading-list-button" onClick={this.handleReadingListClick} title="add to reading list">
                 { this.props.readingListButtonState == ReadingListButtonState.Add 
                 ?  <i className="fa fa-plus"></i>
                 :  <i className="fa fa-check"></i> }                   
                </button>
    }

    private handleReadingListClick(){
        this.props.onReadingListClick && this.props.onReadingListClick(this.props.id);
    }

    private renderFooterLinks(){
        const items = [];

        if(this.props.showAddToReadingListLink 
        && this.props.onReadingListClick != null 
        && this.props.readingListButtonState != ReadingListButtonState.Hidden){
            items.push(<button key={`reading-list-link`} onClick={this.handleReadingListClick}>
                {this.props.readingListButtonState == ReadingListButtonState.Add ? "add to list" : "edit in lists"}
            </button>)
        }

        if(this.props.liveaudioOfferingId){
            items.push(<a key="buy-liveaudio-link" href={`https://www.manning.com/cart/addToCartAndGoThere?productOfferingId=${this.props.liveaudioOfferingId}&quantity=1`} target="_blank">buy liveAudio</a>);
        }

        if(this.props.isLiveproject || this.props.isLivevideo || this.props.isLivebook || this.props.isLiveprojectSeries){
            items.push(<a key={`download-read`} href={this.props.link}>
                            {(this.props.isLivevideo || this.props.isLiveproject) ? "view" : "read"}
                        </a>)
        }

        if(this.props.licenses) {
            for(const license of this.props.licenses){
                items.push(<a key={`download-${license.format}`} href={license.link} target="_blank">{license.format}</a>);
            }
        }

        return items;
    }
}